import React from 'react'
import { ShadowBox, colors } from '../../styles'
import styled from 'react-emotion'
import Image from './Image'
import getText from '../strings';
import { ga } from '../../application'


const Container = styled(ShadowBox)`
  display: flex;
  padding: 0;
  cursor: pointer;
  @media (max-width: 992px) {
    flex-direction: column;
    padding-bottom: 15px;
  }
`

const ContentWrapper = styled('div')`  
  flex-grow: 1;
  padding: 15px;
  color: ${colors.tui_dark_blue};
  .localized-date {
    font-weight: bold
  }
`

export default ({ link }) => {
  const handleClick = () => {
    ga.buttonClick('excursion-show')
    window.open(link, '_blank')
  }

  return (
    <Container onClick={handleClick}>
      <Image image={"/cdn/img/customer/excursions.jpg"} />
      <ContentWrapper>
        <h3>{getText('excursion', 'puff', 'title')}</h3>
        <p>{getText('excursion', 'puff', 'description')}</p>
      </ContentWrapper>
    </Container>
  )
}